import { cn } from '@lib/util/cn';
import type { ComponentPropsWithoutRef, ElementType } from 'react';

type TextProps<T extends ElementType = 'p'> = {
  as?: T;
  size?: string;
} & Omit<ComponentPropsWithoutRef<T>, 'size'>;

/**
 * Polymorphic Text component that renders semantic HTML without
 * injecting any typography styles — relies entirely on token-backed
 * utility classes (typography-paragraph-lg, typography-heading-sm, etc.).
 */
function Text<T extends ElementType = 'p'>({
  as,
  className,
  size: _size,
  ...props
}: TextProps<T>) {
  const Component = (as || 'p') as ElementType;
  return <Component className={cn(className)} {...props} />;
}

Text.displayName = 'Text';

export { Text, type TextProps };
